import { useGtm } from "@gtm-support/vue-gtm";
import { getDomainFromEmail, maskEmail } from "@coronet/cui";
import { CoralogixRum } from "@coralogix/browser";
import { useWorkspaceStore } from "@/_store/workspace.module.ts";
import { useAccountStore } from "@/_store/account.module";

/**
 * Tracks a GTM event enriched with workspace and user context.
 * @sideEffects — reads workspace/account stores, calls GTM tracking
 * @param event - GTM event name
 * @param payload - Event payload string
 */
export const trackGtmEvent = (event: string, payload: string) => {
  const workspaceStore = useWorkspaceStore();
  const account = useAccountStore();
  const gtm = useGtm();
  if (gtm?.enabled()) {
    gtm.trackEvent({
      event,
      payload,
      subscriptionType: workspaceStore?.workspace?.subscriptionType || "",
      workspaceType: workspaceStore?.workspace?.type || "",
      workspaceId: workspaceStore?.workspace?.workspaceId || "",
      userDomain: getDomainFromEmail(account.email) || "",
    });
  }
};
/**
 * Sends the current user/workspace context to Coralogix RUM.
 * Called on workspace change so RUM sessions are tagged with workspace metadata.
 * No-ops safely when RUM is not initialized (non-monitored environments).
 * @sideEffects — reads workspace/account stores, sets Coralogix RUM user context
 */
export const setCoralogixUserContext = () => {
  const workspaceStore = useWorkspaceStore();
  const account = useAccountStore();
  const { workspaceId, type, subscriptionType, isCoronetWorkspace } = workspaceStore.workspace;
  if (!workspaceId) return;
  const maskedEmail = maskEmail(account.email);
  CoralogixRum.setUserContext({
    user_id: `${workspaceId}+${maskedEmail}`,
    user_name: maskedEmail,
    user_email: maskedEmail,
    user_metadata: {
      workspaceType: type,
      subscriptionType,
      isCoroEmployee: isCoronetWorkspace,
      workspaceId,
    },
  });
};
